<template>
  <div id="app">
    <div id="navbar">
      <router-link to="/" id="portfolio-link" class="link">Portfolio</router-link>
      <router-link to="Bio" id="bio-link" class="link">Biography</router-link> 
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import Portfolio from './components/Portfolio.vue'
import Bio from './components/Bio.vue'


export default {
  name: 'app',
  components: {
    Portfolio,
    Bio
  }
}
</script>

<style>
div#navbar > .link{
  padding-left: 20px;
  margin-bottom: 40px;
}
#navbar{
  margin-bottom: 40px;
  border-bottom: 5px solid black;
  
}

#app {
  margin: auto;
  width: 80%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
#Portfolio {
  display: block;
}
#bio {
  display: none;
}

router-view{
  margin: auto;
}
</style>
